import * as React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/I18nProvider";

const MAPS_URL =
  "https://www.google.com/maps/place/Gafsa/@34.4285913,8.7736605,14z/data=!3m1!4b1!4m6!3m5!1s0x12f896fa5476901f:0x873608732b8975d5!8m2!3d34.4311398!4d8.7756556!16zL20vMDZoMW04!5m2!1e4!1e1?entry=ttu";

const NAV_ITEMS = [
  { path: "/", key: "nav.home" },
  { path: "/about", key: "nav.about" },
  { path: "/portfolio", key: "nav.portfolio" },
  { path: "/blog", key: "nav.blog" },
  { path: "/contact", key: "nav.contact" },
];

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useI18n();
  const waText = t("whatsapp.prefill");

  const socials = React.useMemo(
    () => [
      {
        id: "facebook",
        icon: "fa-facebook",
        href: "https://www.facebook.com/hasnaoui1993/",
      },
      {
        id: "instagram",
        icon: "fa-instagram",
        href: "https://www.instagram.com/abdenacer_hasnaoui/",
      },
      {
        id: "github",
        icon: "fa-github",
        href: "https://github.com/abdenacer1993",
      },
      {
        id: "linkedin",
        icon: "fa-linkedin",
        href: "https://www.linkedin.com/in/abdenacer-hasnaoui-91bb86211/",
      },
      {
        id: "whatsapp",
        icon: "fa-whatsapp",
        href: `https://wa.me/21624587616?text=${encodeURIComponent(waText)}`,
      },
    ],
    [waText]
  );

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer_section site-footer__main">
        <div className="container">
          <div className="row site-footer__grid">
            <div className="col-lg-4 col-md-6 site-footer__brand">
              <Link to="/" className="site-footer__logo-link">
                <img src="/images/logo.png" alt="" className="site-footer__logo" />
              </Link>
              <p className="site-footer__name">{t("hero.name")}</p>
              <p className="site-footer__tagline">{t("hero.role")}</p>
              <p className="site-footer__pitch">{t("hero.tagline")}</p>
            </div>

            <div className="col-lg-2 col-md-6 site-footer__col">
              <h2 className="site-footer__heading">{t("footer.sectionNav")}</h2>
              <nav className="site-footer__nav" aria-label={t("footer.sectionNav")}>
                <ul className="site-footer__nav-list">
                  {NAV_ITEMS.map((item) => (
                    <li key={item.path}>
                      <Link to={item.path} className="site-footer__nav-link">
                        {t(item.key)}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>

            <div className="col-lg-3 col-md-6 site-footer__col">
              <h2 className="site-footer__heading">{t("footer.sectionContact")}</h2>
              <ul className="site-footer__contact-list">
                <li>
                  <a
                    href={MAPS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="site-footer__contact-link"
                  >
                    <i className="fa fa-map-marker" aria-hidden="true" />
                    <span>{t("footer.location")}</span>
                  </a>
                </li>
                <li>
                  <a href="tel:+21624587616" className="site-footer__contact-link">
                    <i className="fa fa-phone" aria-hidden="true" />
                    <bdi dir="ltr">{t("footer.phoneDisplay")}</bdi>
                  </a>
                </li>
                <li>
                  <a
                    href="mailto:abdenacer1993@gmail.com"
                    className="site-footer__contact-link"
                  >
                    <i className="fa fa-envelope" aria-hidden="true" />
                    <span>abdenacer1993@gmail.com</span>
                  </a>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 site-footer__col">
              <h2 className="site-footer__heading">{t("footer.sectionFollow")}</h2>
              <p className="site-footer__social-intro">{t("footer.socialIntro")}</p>
              <ul className="site-footer__social">
                {socials.map((s) => (
                  <li key={s.id}>
                    <a
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="site-footer__social-btn"
                      aria-label={t(`footer.socialAria.${s.id}`)}
                    >
                      <i className={`fa ${s.icon}`} aria-hidden="true" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="copyright_section site-footer__bottom">
        <div className="container">
          <p className="copyright_text site-footer__copyright">
            <span>{t("footer.copyright", { year: currentYear })}</span>
            <span className="site-footer__copyright-sep" aria-hidden>
              {" "}
              ·{" "}
            </span>
            <span>{t("footer.rights")}</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
